var menuStyleFn = function menuStyleFn(token) {
  return {
    '.ant-menu': {
      fontWeight: 400,
      '.ant-menu-submenu-expand-icon,.ant-menu-submenu-arrow': {
        insetInlineEnd: 12
      },
      '.ant-menu-submenu-selected,.ant-menu-item-selected': {
        '.ant-menu-item-icon': {
          position: 'relative',
          svg: {
            zIndex: 1
          },
          color: '#fff',
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '-7px',
            left: '-7px',
            right: '-7px',
            bottom: '-7px',
            backgroundColor: token.colorPrimary,
            borderRadius: '12px'
          }
        }
      },
      '.ant-menu-submenu-title .anticon': {
        transition: 'none'
      }
    },
    '.ant-menu:not(.ant-menu-horizontal)': {
      padding: '20px 12px'
      // '&.ant-menu-root >.ant-menu-item': {
      //   paddingLeft: `16px !important`,
      // },
      // '&.ant-menu-root >.ant-menu-submenu >.ant-menu-submenu-title': {
      //   paddingLeft: `16px !important`,
      // },
    },
    '.ant-menu-light': {
      '&.ant-menu-horizontal': {
        '.ant-menu-item': {
          color: token.colorText
        },
        '.ant-menu-item-selected': {
          color: token.colorText,
          fontWeight: token.fontWeightStrong
        }
      },
      '>.ant-menu-item,.ant-menu-submenu-title': {
        color: token.colorText
      },
      '.ant-menu-item-group-title': {
        color: token.colorBorder
      },
      '.ant-menu-item-selected': {
        fontWeight: token.fontWeightStrong
      },
      // 一级item选中变色
      '> .ant-menu-item-selected': {
        backgroundColor: "" + token.colorFillSecondary
      },
      '.ant-menu-submenu-selected': {
        '>.ant-menu-submenu-title': {
          color: token.colorText,
          fontWeight: token.fontWeightStrong
        }
      },
      // 仅light模式下 一级菜单标题选中变色
      '&:not(.ant-menu-horizontal):not(.ant-menu-inline-collapsed) >.ant-menu-submenu-selected': {
        '>.ant-menu-submenu-title': {
          backgroundColor: "" + token.colorFillSecondary
        }
      },
      // 箭头
      '.ant-menu-submenu-arrow': {
        color: token.colorTextSecondary
      },
      // 二级菜单
      '.ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow': {
        color: token.colorText
      }
    }
  };
};

export { menuStyleFn };
